<!--
  TicketPreviewCard:门票 / 演唱会票卡预览。
  用于 F-success 与 wish 详情弹窗;图片素材来自 Figma,动态文本仍由接口数据渲染。
-->
<template>
  <div
    class="ticket-preview-card"
    :class="[`page-${pageType}`, `variant-${variant}`]"
  >
    <div class="preview-hero">
      <img
        v-if="variant === 'ticket'"
        class="preview-image"
        :src="pageType === 'PC' ? matchCardPcBg : matchCardBg"
        alt=""
      />
      <img
        v-else
        class="preview-image"
        :src="pageType === 'PC' ? concertCardPcBg : concertCardBg"
        alt=""
      />
      <template v-if="variant === 'ticket'">
        <span
          class="team-name team-home"
          :style="teamNameStyle(homeTeam, pageType)"
        >
          {{ homeTeam }}
        </span>
        <span
          class="team-name team-away"
          :style="teamNameStyle(awayTeam, pageType)"
        >
          {{ awayTeam }}
        </span>
      </template>
    </div>

    <div class="info-panel">
      <div
        v-for="(row, idx) in rows"
        :key="idx"
        class="row"
      >
        <span class="row-label">{{ row.label }}</span>
        <span
          v-if="!isTicketRow(row)"
          class="row-value"
        >
          {{ row.value }}
        </span>
        <img
          v-else
          class="ticket-badge"
          :src="ticketBadge"
          :alt="row.value"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import matchCardBg from '../assets/bg-ticket-match-card.png';
import matchCardPcBg from '../assets/bg-ticket-match-card-pc.png';
import concertCardBg from '../assets/bg-ticket-concert-card.png';
import concertCardPcBg from '../assets/bg-ticket-concert-card-pc.png';
import ticketBadge from '../assets/badge-suite-ticket-x2.png';
type Row = {
  label: string;
  value: string;
};
type Props = {
  pageType: 'PC' | 'H5';
  variant: 'ticket' | 'concert';
  rows: Row[];
  homeTeam?: string;
  awayTeam?: string;
};
const __sfc_main = {};
__sfc_main.props = {
  pageType: {
    key: "pageType",
    required: true,
    type: String
  },
  variant: {
    key: "variant",
    required: true,
    type: String
  },
  rows: {
    key: "rows",
    required: true,
    type: Array
  },
  homeTeam: {
    key: "homeTeam",
    required: false,
    type: String,
    default: 'Mets'
  },
  awayTeam: {
    key: "awayTeam",
    required: false,
    type: String,
    default: 'Miami'
  }
};
__sfc_main.setup = (__props, __ctx) => {
  function isTicketRow(row: Row): boolean {
    return row.label.trim().toLowerCase() === 'ticket';
  }
  function visualLength(text: string): number {
    let total = 0;
    for (const char of text.trim()) {
      total += /[\u3400-\u9fff]/.test(char) ? 1.8 : 1;
    }
    return total;
  }
  function teamFontSize(name: string, pageType: 'PC' | 'H5'): string {
    const len = visualLength(name);
    if (pageType === 'H5') {
      if (len <= 4) return '0.42rem';
      if (len <= 6) return '0.34rem';
      if (len <= 8) return '0.3rem';
      return '0.25rem';
    }
    if (len <= 4) return '22px';
    if (len <= 6) return '18px';
    if (len <= 8) return '16px';
    return '13px';
  }
  function teamNameStyle(name: string, pageType: 'PC' | 'H5'): Record<string, string> {
    return {
      fontSize: teamFontSize(name, pageType)
    };
  }
  return {
    matchCardBg,
    matchCardPcBg,
    concertCardBg,
    concertCardPcBg,
    ticketBadge,
    isTicketRow,
    teamNameStyle
  };
};
export default __sfc_main;
</script>

<style scoped>
.ticket-preview-card,
.preview-hero,
.info-panel,
.row {
  box-sizing: border-box;
}

.ticket-preview-card {
  display: flex;
  flex-direction: column;
}

.preview-hero {
  position: relative;
  overflow: hidden;
}

.preview-image {
  display: block;
  width: 100%;
  height: 100%;
}

.team-name {
  position: absolute;
  display: block;
  color: #ff6900;
  font-weight: 700;
  line-height: 1.2em;
  text-align: center;
  overflow-wrap: break-word;
  word-break: break-all;
  transform: translate(-50%, -50%);
}

.info-panel {
  display: flex;
  flex-direction: column;
  background: #ffffff;
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.row + .row {
  border-top: 0.02rem dashed #e4e4e4;
}

.row-label {
  color: #7a7a7a;
  font-weight: 400;
}

.row-value {
  color: #000000;
  font-weight: 600;
  text-align: right;
}

.ticket-badge {
  display: block;
}

/* H5:设计稿 100px = 1rem */
.page-H5.ticket-preview-card {
  width: 6.54rem;
}

.page-H5.variant-ticket .preview-hero {
  width: 6.54rem;
  height: 3.16rem;
}

.page-H5.variant-concert .preview-hero {
  width: 6.54rem;
  height: 2rem;
}

.page-H5 .team-name {
  top: 1.98rem;
  width: 1.6rem;
}

.page-H5 .team-home {
  left: 1.6rem;
}

.page-H5 .team-away {
  left: 4.94rem;
}

.page-H5 .info-panel {
  width: 6.54rem;
  padding: 0.3rem 0.2rem;
  gap: 0;
  border: 0.02rem solid #dedede;
  border-radius: 0.2rem;
}

.page-H5 .row {
  min-height: 0.58rem;
}

.page-H5 .row + .row {
  margin-top: 0.18rem;
  padding-top: 0.18rem;
}

.page-H5 .row-label {
  font-size: 0.28rem;
  line-height: 1.2em;
}

.page-H5 .row-value {
  font-size: 0.3rem;
  line-height: 1.2em;
}

.page-H5 .ticket-badge {
  width: 2.9rem;
  height: 0.51rem;
}

/* PC:成功 / 售空弹窗按 Figma 将票面与信息卡左右并排。 */
.page-PC.ticket-preview-card {
  width: 700px;
  flex-direction: row;
  gap: 0;
}

.page-PC.variant-ticket .preview-hero {
  width: 350px;
  height: 240px;
  border-radius: 20px;
}

.page-PC.variant-concert .preview-hero {
  width: 350px;
  height: 240px;
  border-radius: 20px;
}

.page-PC .team-name {
  top: 152px;
  width: 95px;
}

.page-PC .team-home {
  left: 0.84rem;
}

.page-PC .team-away {
  left: 2.68rem;
}

.page-PC .info-panel {
  display: grid;
  grid-template-rows: repeat(3, 1fr);
  width: 350px;
  height: 240px;
  padding: 32px 24px;
  background: #f3f3f5;
  border: 1px solid #0041ac;
  border-radius: 20px;
}

.page-PC .row {
  min-height: 0;
}

.page-PC .row + .row {
  margin-top: 0;
  padding-top: 0;
  border-top: 1px dashed #e4e4e4;
}

.page-PC .row-label {
  font-size: 16px;
  line-height: 1.2em;
}

.page-PC .row-value {
  font-size: 18px;
  line-height: 1.2em;
}

.page-PC .ticket-badge {
  width: 155px;
  height: 27px;
}
</style>
